export interface QuickSaveLock {
  current: boolean;
}

export function tryBeginQuickProjectSave(lock: QuickSaveLock): boolean {
  if (lock.current) return false;
  lock.current = true;
  return true;
}
